const riot = require('riot');

riot.tag2('atom-reload-button', '<button class="f fh s16" onclick="{handleClick}"><img class="s-full object-fit-contain" src="/images/icons/reload.png"></button>', '', '', function(opts) {
    this.handleClick = () => {
      this.trigger('click');
    };
});